import { produce } from 'immer';
import { booleanParser, numberParser } from '../../api/inbound/inboundParsers';
import { ADD_ROOMS_TO_LOBBY, CLEAR_LOBBY_SCENE, ENTER_LOBBY_PLAYER_FROM_INBOUND, HIDE_LOBBY_PRIZE_WIN, LEAVE_LOBBY_PLAYER_FROM_INBOUND, LOBBY_BROWSE_FROM_INBOUND, REMOVE_ROOM_FROM_LOBBY, RENAME_LOBBY_ROOM_FROM_INBOUND, SET_LOBBY_PLAYER_BANK, SHOW_LOBBY_PRIZE_WIN_FROM_INBOUND, UPDATE_LOBBY_ROOM_FROM_INBOUND, UPDATE_LOBBY_ROOM_VARIABLE_FROM_INBOUND } from '../actions/lobbyActions';
const initialState = {
    lobbyRooms: [],
    lobbyPlayers: []
};
const lobbyReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_LOBBY_SCENE: {
                return initialState;
            }
            case LOBBY_BROWSE_FROM_INBOUND: {
                const { lobbyPlayers, currentRoomId } = action.payload;
                draft.lobbyPlayers = lobbyPlayers;
                draft.showLobbyTraffic = true; // TODO: Use player setting (from action.payload.showLobbyTraffic)
                if (currentRoomId !== -1) {
                    draft.currentRoomId = currentRoomId;
                }
                break;
            }
            case ENTER_LOBBY_PLAYER_FROM_INBOUND: {
                // Multiple lobby players with the same ID are allowed (multiple login sessions, but only one per ID playing in a room),
                // so compare the client code to determine if this is a new session or an existing one.
                const existingPlayerIndex = draft.lobbyPlayers.findIndex((lobbyPlayer) => lobbyPlayer.sessionId === action.payload.lobbyPlayer.sessionId);
                if (existingPlayerIndex !== -1) {
                    // update player matching this client code in place:
                    draft.lobbyPlayers[existingPlayerIndex] = action.payload.lobbyPlayer;
                }
                else {
                    // no lobby player exists yet with this client code, add it:
                    draft.lobbyPlayers.push(action.payload.lobbyPlayer);
                }
                break;
            }
            case LEAVE_LOBBY_PLAYER_FROM_INBOUND: {
                draft.lobbyPlayers = draft.lobbyPlayers.filter((lobbyPlayer) => lobbyPlayer.sessionId !== action.payload.sessionId);
                break;
            }
            case ADD_ROOMS_TO_LOBBY: {
                draft.lobbyRooms = draft.lobbyRooms.concat(action.payload);
                break;
            }
            case REMOVE_ROOM_FROM_LOBBY: {
                draft.lobbyRooms = draft.lobbyRooms.filter((lobbyRoom) => lobbyRoom.roomId !== action.payload);
                break;
            }
            case SET_LOBBY_PLAYER_BANK: {
                const existingPlayer = draft.lobbyPlayers.find((player) => player.id === action.payload.playerId);
                if (existingPlayer) {
                    existingPlayer.numChipsInBank = action.payload.numChipsInBank;
                }
                break;
            }
            case UPDATE_LOBBY_ROOM_FROM_INBOUND: {
                const existingLobbyRoomIndex = draft.lobbyRooms.findIndex((lobbyRoom) => lobbyRoom.roomId === action.payload.lobbyRoom.roomId);
                if (existingLobbyRoomIndex !== -1) {
                    draft.lobbyRooms[existingLobbyRoomIndex] = action.payload.lobbyRoom;
                }
                break;
            }
            case UPDATE_LOBBY_ROOM_VARIABLE_FROM_INBOUND: {
                const { roomId, roomVarName, roomVarValueString } = action.payload;
                const existingLobbyRoom = draft.lobbyRooms.find((lobbyRoom) => lobbyRoom.roomId === roomId);
                if (existingLobbyRoom) {
                    switch (roomVarName) {
                        case 'has_open_seat': {
                            existingLobbyRoom.hasOpenSeat = booleanParser(roomVarValueString);
                            break;
                        }
                        case 'players_sitting': {
                            // apparently unused in Flash client
                            const numPlayersSitting = numberParser(roomVarValueString);
                            if (numPlayersSitting !== -1) {
                                existingLobbyRoom.numPlayersSitting = numPlayersSitting;
                            }
                            else {
                                delete existingLobbyRoom.numPlayersSitting;
                            }
                            break;
                        }
                        default: {
                            console.warn(`Unrecognized lobby room var ${roomVarName}`);
                        }
                    }
                }
                break;
            }
            case RENAME_LOBBY_ROOM_FROM_INBOUND: {
                const { roomId, newName } = action.payload;
                const existingLobbyRoom = draft.lobbyRooms.find((lobbyRoom) => lobbyRoom.roomId === roomId);
                if (existingLobbyRoom) {
                    existingLobbyRoom.roomName = newName;
                }
                break;
            }
            case SHOW_LOBBY_PRIZE_WIN_FROM_INBOUND: {
                const { winnerId, messageToOthers, messageToWinner, prizeDescription, durationMs } = action.payload;
                draft.prizeWin = { winnerId, messageToOthers, messageToWinner, prizeDescription, durationMs };
                break;
            }
            case HIDE_LOBBY_PRIZE_WIN: {
                delete draft.prizeWin;
                break;
            }
            default: {
                return state;
            }
        }
    });
};
export default lobbyReducer;
